import { orderHotelsById, sortRoomsByPrice } from '@shared/helpers';

export const sortHotels = (hotels, orderHotelsBy) => {
  const needsSort = +orderHotelsBy !== 0;
  const input = needsSort ? sortRoomsByPrice(hotels, true) : hotels;
  return orderHotelsById(orderHotelsBy, input);
};
